<template>
    <div>
        <div class="row justify-content-between">
            <div class="col-12 col-md-12 col-lg-12 col-xl-8">
                <div class="row">
                    <div class="col-6 col-md-4 col-lg-5">
                        <label>ค้นหาวันที่ยกเลิก</label>
                        <date-range-picker
                            class="w-100"
                            :opens="'center'"
                            @start-selection="logEvent('startSelection', $event)"
                            @finish-selection="logEvent('finishSelection', $event)"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :singleDatePicker="false"
                            :appendToBody="true"
                            :ranges="false"
                            :closeOnEsc="false"
                            :autoApply="true"
                            :locale-data="{ format: 'dd/mm/yyyy' }"
                            v-model="search.date">
                        </date-range-picker>
                    </div>
                    <div class="col-6 col-md-4 col-lg-5 mb-3">
                        <label>ค้นหารหัสรายการ หรือ หมายเลขติดตามพัสดุ</label>
                        <b-form-input
                            type="text"
                            placeholder="ค้นหาข้อมูล"
                            v-model="search.filter"
                        ></b-form-input>
                    </div>
                    <div class="col-12 col-md-3 col-lg-2 d-flex align-items-center pt-3">
                        <button class="btn btn-info btn-sm-res" @click="$emit('historyCancel')">
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
                <hr class="d-md-block d-lg-none" />
            </div>
            <div class="col-12 col-md-6 col-lg-2 col-xl-3">
                <label>ตัวกรอง</label>
                <select class="form-control" v-model="search.status">
                    <option :value="null">
                        {{search.status === null? 'กรุณาเลือกสถานะ' : 'ดูสถานะทั้งหมด'}}
                    </option>
                    <option :value="status.key" v-for="status in dataStatus" :key="status.key">{{status.title}}</option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import { dateLimitRanges } from "@/plugins/datePicker.js"
export default {
    props:{
        search:Object,
    },
    data(){
        return{    
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),   
            dataStatus:[
                { key: 'PENDING_CANCEL' , title: 'รอดำเนินการยกเลิก' },        
                { key: 'CANCEL' , title: 'ยกเลิกสำเร็จแล้ว' },
                { key: 'CANCEL_FAIL' , title: 'ยกเลิกไม่สำเร็จ' }
            ]
        }
    },
    methods:{
        logEvent( event , date ){
            const { minDate , maxDate } =  dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
    }
}
</script>